class Utility {
    // Method to get the difference in days between two dates
    static getDaysDifference(date1, date2 = new Date()) {
      const diffTime = Math.abs(new Date(date2) - new Date(date1));
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    }
  
    // Method to calculate consumed quantity and round it off
    static getConsumed(item) {
      item.consumed = item.qty - item.b_qty;
      return Utility.getRoundOff(item.consumed, true);
    }
  
    // Method to format seconds to "mm:ss"
    static formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    }
  
    // Method to format date as DD-MM-YY
    static formatDateToDDMMYY(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString().slice(-2);
      return `${day}-${month}-${year}`;
    }
  
    // Method to round off a number to 3 decimal places
    static getRoundOff(num, toFixed) {
      if (toFixed === true) {
        return (Math.round((num + Number.EPSILON) * 1000) / 1000).toFixed(3);
      }
      return Math.round((num + Number.EPSILON) * 1000) / 1000;
    }

    static encodeString(str) {
      if(str == null) return null;
      return btoa(str); // Base64 encoding
    }
  
    static decodeString(str) {
      if(str == null) return null;
      return atob(str); // Base64 decoding
    }
  }
  
  export default Utility;
  